var tdaContext = {
  contextMap: {
    BOS10: 'NewEngland',
    CAT10: 'CentralAtlantic',
    CHI10: 'Midwest',
    CIN10: 'MY-OH-KY-TN',
    CON10: 'Connecticut',
    DVR10: 'Denver',
    GNY10: 'GreaterNY',
    GOC10: 'GoldCoast',
    GST10: 'GST',
    INW10: 'InlandNorthWest',
    KAC10: 'Central',
    NCA10: 'Norcal',
    PHX10: 'Phoenix',
    PTL10: 'PacificNorthwest',
    SET10: 'SouthEastToyota',
    SND10: 'SanDiego',
    SOC10: 'SoCal',
    TRE10: 'TriStateEast',
    TRI10: 'TriState',
    UST10: 'UpstateNY',
    WWN10: 'WesternWashington',
    WWW: '',
  },

  getReadableContext: function (tdaCode) {
    return this.contextMap[tdaCode];
  }
};

export default tdaContext;
